/*

Controller file for Leases

*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import moment from 'moment'

var Financial = Class.create({
  	initialize: function() {
		this.limit = 'month';
		this.type = 'income';
	},
	getIncome: function(startDate, endDate, callback) {
		const params = {
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD")
		}
        var url = 'financial/income';
		// #  Send to server object for processing
		var data = server.getData(url, params, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getExpense: function(startDate, endDate, callback) {
		const params = {
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD")
		}
        var url = 'financial/expense';
		// #  Send to server object for processing
		var data = server.getData(url, params, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getTransactionHistory: function(startDate, endDate, callback) {
		const params = {
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD")
		}
		var url = 'financial/transactions';
		// #  Send to server object for processing
		var data = server.getData(url, params, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	addTransaction: function(transaction, callback) {
		var url = "financial/transaction";
		var data = server.getData(url, transaction, true, "POST");
		data
		.done(function(response) {
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
				modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Error occurred: " + e + ". Please try again", "danger", "top", "center");
		});
	},
	updateTransaction: function(transaction, callback) {
		var url = "financial/transaction";
		var data = server.getData(url, transaction, true, "PUT");
		data
		.done(function(response) {
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
				modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Error occurred: " + e + ". Please try again", "danger", "top", "center");
		});
	},
	getTransaction: function(id, callback) {
		var url = "financial/transaction/" + id;
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response) {
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
				modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Error occurred: " + e + ". Please try again", "danger", "top", "center");
		});
	},
	deleteTransaction: function(transactionId, callback) {
		modal.showDangerModalWithOK("Are you sure?","You are about to delete this transaction.","Yes, Delete");
		jQuery(".move-on").on('click',function() {
			var url = "financial/transaction/" + transactionId;
			var params = null;
			var data = server.getData(url, params, true, "DELETE");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1) {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2)) {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                }
                if(callback) {
                    callback(response);
                }
			})
			.fail(function(e){
                modal.resetBackDrop();
				modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
			});
		});
    },
	getPendingRent: function(callback) {
        var url = 'financial/pendingrent';
		// #  Send to server object for processing
		var data = server.getData(url,null, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getMaintenanceExpense: function(callback) {
        var url = 'financial/expense/maintenance?limit=' + this.limit;
		// #  Send to server object for processing
		var data = server.getData(url,null,true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getLateRent: function(startDate, endDate, callback) {
		const params = {
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD")
		}
        var url = 'financial/income/laterent';
		var data = server.getData(url, params, true);
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getRentReceived: function(startDate, endDate, callback) {
		const params = {
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(startDate).format("YYYY-MM-DD")
		}
        var url = 'financial/income/rentreceived';
		var data = server.getData(url, params, true);
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	updateLateRentFee: function(fee, callback) {
		var url = "financial/fee/laterent";
		var data = server.getData(url, fee, true, "PUT");
		data
		.done(function(response) {
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
				modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Error occurred: " + e + ". Please try again", "danger", "top", "center");
		});
	},
	getLateRentFee: function(callback) {
		var url = "financial/fee/laterent";
		// #  Send to server object for processing
		var data = server.getData(url,null,true);
		// #  Listen to our data
		data
		.done(function(response){
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
				modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getFinancialStats: function(callback) {
		var url = "financial/stats?limit=month";
		var data = server.getData(url,null,true);
		data
		.done(function(response){
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
				modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getIncomeData: function(callback) {
		const params = {
            limit: this.limit
		}
		var url = "financial/income/chart";
		var data = server.getData(url, params, true, 'GET');
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong while retrieving the Income chart data!", "danger", "top", "center");
		});
	},
	getExpenseData: function(callback) {
		const params = {
            limit: this.limit
		}
		var url = "financial/expense/chart";
		var data = server.getData(url, params, true, 'GET');
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong while retrieving the Expenses chart data!", "danger", "top", "center");
		});
	},

	setLimit(value) {
		this.limit = value;
	},
	getChartData: function(startDate, endDate, callback, type = "income") {
		const params = {
            start_date: moment(startDate).format('YYYY-MM-DD'),
            end_date: moment(endDate).format('YYYY-MM-DD')
		}
        var url = type == "income" ? "financial/income/chart" :
            "financial/expense/chart";
		var data = server.getData(url, params, true, 'GET');
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong while retrieving chart data!", "danger", "top", "center");
		});
	},
	// TODO
	setType(value) {
		this.type = value;
	}
});

export let financial = new Financial();


// WEBPACK FOOTER //
// app/core/controllers/Financial.js